import React, { useEffect, useState } from "react";
import { IndianRupee } from "lucide-react";
import Dropdown from "../../../components/Dropdown";
import AddVectorIcon from "../../../assets/Icons/Add Vector.png";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import { axiosGetApi, axiosPostApi } from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";
import SuccessModal from "../../../components/successModal/successModal";
import CustomAlert from "../../../helpers/CustomAlert";
import DuplicateModal from "./DuplicateModal";

const sourceOptions = [
  { label: "Within City", value: "WITHIN_CITY" },
  { label: "Within Zone", value: "WITHIN_ZONE" },
  { label: "Within Metro", value: "WITHIN_METRO" },
  { label: "Rest of India", value: "REST_OF_INDIA" },
  { label: "Special India", value: "SPECIAL_INDIA" },
  { label: "Receiver Metro", value: "RECEIVER_METRO" },
];

const expressOptions = [
  { label: "Air", value: "AIR" },
  { label: "Surface", value: "SURFACE" },
];

const AddChargeMasterMultiModal = ({ show, handleClose, callApi, setCurrentPage }) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [cardOptions, setCardOptions] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setsuccessMessage] = useState("");
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateData, setDuplicateData] = useState(null);
  const [finalPayload, setFinalPayload] = useState(null);
  
  const [commonData, setCommonData] = useState({
    rateCardType: "",
    source: "",
    express: "",
  });

  const [rows, setRows] = useState([
    {
      weight: "",
      height: "",
      length: "",
      width: "",
      chargesAmount: "",
      fuelCharges: "",
      gst: "",
      totalCharges: "",
      additionalWeightUnit: "",
      additionalRate: "",
    },
  ]);

  const addRow = () => {
    setRows([
      ...rows,
      {
        weight: "",
        height: "",
        length: "",
        width: "",
        chargesAmount: "",
        fuelCharges: "",
        gst: "",
        totalCharges: "",
        additionalWeightUnit: "",
        additionalRate: "",
      },
    ]);
  };

  const removeRow = (index) => {
    const updated = [...rows];
    updated.splice(index, 1);
    setRows(updated);
  };

  const [errors, setErrors] = useState({});

  const validateAllRows = () => {
  let newErrors = {};
  let isValid = true;

  if (!commonData.rateCardType) {
      newErrors.rateCardType = "Please select a Rate Card Type";
    }
    if (!commonData.express.trim()) {
      newErrors.express = "Please select an Express Type";
    }
    if (!commonData.source.trim()) {
      newErrors.source = "Please select a Source";
    }

  rows.forEach((row, i) => {
    newErrors[i] = {};

    Object.keys(row).forEach((field) => {
      if (field === "totalCharges") return;

      const value = row[field];

      if (!value) {
        newErrors[i][field] = "Required";
        isValid = false;
      } else if (isNaN(value)) {
        newErrors[i][field] = "Invalid";
        isValid = false;
      } else if (Number(value) < 0) {
        newErrors[i][field] = "Must be ≥ 0";
        isValid = false;
      }
    });
  });

  setErrors(newErrors);
  return isValid;
};

const validateField = (index, field, value) => {
  let error = "";

  if (!value) {
    error = "Required";
  } else if (isNaN(value)) {
    error = "Invalid";
  } else if (Number(value) < 0) {
    error = "Must be ≥ 0";
  } else {
    // format like 1 => 1.00
    const updated = [...rows];
    updated[index][field] = formatToTwoDecimals(value);

    const amt = Number(updated[index].chargesAmount) || 0;
    const fuel = Number(updated[index].fuelCharges) || 0;
    const gst = Number(updated[index].gst) || 0;

    const gstAmount = ((amt + fuel) * gst) / 100;
    updated[index].totalCharges = (amt + fuel + gstAmount).toFixed(2);

    setRows(updated);
  }

  setErrors((prev) => ({
    ...prev,
    [index]: {
      ...prev[index],
      [field]: error,
    },
  }));
};

const preparePayload = (formData, slabs) => ({
  username: loggedInUserName,
  source: formData.source,
  express: formData.express,
  rateCardId: formData.rateCardType,
  slabs: slabs.map((item) => ({
    weight: Number(item.weight),
    height: Number(item.height),
    length: Number(item.length),
    width: Number(item.width),
    amount: Number(item.chargesAmount),
    fuelCharges: Number(item.fuelCharges),
    gst: Number(item.gst),
    additionalWeightUnit: Number(item.additionalWeightUnit),
    additionalRate: Number(item.additionalRate),
  })),
});

const handleSubmit = () => {
   const isValid = validateAllRows();
  if (!isValid) return;

  // const payload = rows.map((row) => ({
  //   ...row,
  //   ...commonData,
  // }));
  const payload = preparePayload(commonData, rows);
  handleValidateCharges(payload);
};

const handleValidateCharges = async (chargesPayload) => {
  try {
    const response = await axiosPostApi(apiList.VALIDATE_BULK_CHARGE_MASTER, chargesPayload);
     const data = response?.data;

     if (data?.status === true && 
        data?.respCode === "00" && 
        data?.data?.actionRequired === true) {
          setDuplicateData(data.data);
          setFinalPayload(chargesPayload);
          setShowDuplicateModal(true);
    } else {
       handleCreateBulkCharges(chargesPayload, "SKIP");
    }
    
  } catch (error) {
     CustomAlert({
      title: "Error",
      text: `There was an error: ${error?.message}`,
      icon: "error",
      confirmButtonText: "Retry",
    }); 
  }
}

const handleCreateBulkCharges = async (payload, action) => {
  const newPayload = {
    ...payload,
    duplicateAction: action,
  }
  try {
    const response = await axiosPostApi(apiList.CREATE_BULK_CHARGE_MASTER, newPayload);
     const data = response?.data;

     if (data?.status === true && 
        data?.respCode === "00") {
          setShowDuplicateModal(false);
          setsuccessMessage(data.message);
          setShowSuccessModal(true);
          // handleClose();
          callApi(1);
          setCurrentPage(1);
    } else {
        CustomAlert({
          title: "Error",
          text: `Failed to create charge master: ${data?.message || "Unknown error"}`,
          icon: "error",
          confirmButtonText: "Retry",
        });
    }
    
  } catch (error) {
     CustomAlert({
      title: "Error",
      text: `There was an error: ${error?.message}`,
      icon: "error",
      confirmButtonText: "Retry",
    }); 
  }
}
const formatToTwoDecimals = (value) => {
  if (value === "" || value === null || value === undefined) return "";
  const num = parseFloat(value);
  if (isNaN(num)) return "";
  return num.toFixed(2);
};

const handleRowChange = (index, field, value) => {
  if (value && !/^\d*\.?\d{0,2}$/.test(value)) return;

  const updated = [...rows];
  updated[index][field] = value;

  const amt = Number(updated[index].chargesAmount) || 0;
  const fuel = Number(updated[index].fuelCharges) || 0;
  const gst = Number(updated[index].gst) || 0;

  const gstAmount = ((amt + fuel) * gst) / 100;
  updated[index].totalCharges = (amt + fuel + gstAmount).toFixed(2);

  setRows(updated);
};

  useEffect(() => {
    if (!show) return;
    fetchCardData();
  }, [show]);

  const fetchCardData = async () => {
    try {
      const response = await axiosGetApi(`${apiList.ALL_RATE_CARD_DATA}?username=${loggedInUserName}`);

      if ( response?.data?.status === true &&
          response?.data?.respCode === "00"
        ) {
        setCardOptions(response.data.data);
      }
    } catch (err) {
      console.error("Item fetch error", err);
    }
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    handleClose();
  };

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1031,
      }}
    >
      <div className="bg-white w-[1100px] rounded-[20px] p-6 shadow-lg relative border border-gray-200">

        {/* Header */}
        <img
          src={LeftCircle}
          alt="leftImg"
          className="absolute left-0 bottom-0 w-[110px] h-[105px] z-0"
        />
        <img
          src={RightCircle}
          alt="rightImg"
          className="absolute right-0 top-0 w-[110px] h-[105px] z-0"
        />
        {/* Header Content (foreground layer) */}
        <div
          className="flex justify-between items-center mb-3 relative z-10 pb-3"
          style={{
            borderBottom: "1px solid #dee2e6",
          }}
        >
          <div className="flex items-center gap-2">
            <img src={AddVectorIcon} alt="Add" className="w-7 h-7" />
            <h2 className="text-lg font-semibold text-[#FF6600]">
              Add Charges Master
            </h2>
          </div>
          {/* Close Icon */}
          <img
            src={CrossIcon}
            alt="Close"
            onClick={handleClose}
            className="w-5 h-5 cursor-pointer hover:rotate-90 transition-transform z-20"
          />
        </div>

        {/* 🔹 Common Fields */}
        <div className="grid grid-cols-3 gap-4 mb-6">
          {/* Card Type */}
          <div>
            <Dropdown
              label="Rate Card Type"
              value={commonData.rateCardType}
              onChange={(item) => {
                setCommonData((prev) => ({
                  ...prev,
                  rateCardType: item.rateCardId,
                }));
            
                setErrors((prev) => ({
                  ...prev,
                  rateCardType: "",
                }));
              }}
              labelKey="rateCardName"
              valueKey="rateCardId"
              options={cardOptions}
              isRequired
              error={errors.rateCardType}
              // disabled={isReadOnly}
              selectClassName="w-full h-[36px] rounded-md border border-gray-300 pr-2 text-[15px] focus:ring-1 focus:ring-[#FF6600] focus:outline-none"
            />
          </div>

          {/* Source */}
          <div>
            <Dropdown
              label="Source"
              value={commonData.source}
              onChange={(item) => {
                setCommonData((prev) => ({
                  ...prev,
                  source: item.value,
                }));
            
                setErrors((prev) => ({
                  ...prev,
                  source: "",
                }));
              }}
              options={sourceOptions}
              error={errors.source}
              isRequired
              selectClassName="w-full h-[36px] rounded-md border border-gray-300 pr-2 text-[15px] focus:ring-1 focus:ring-[#FF6600] focus:outline-none"
            />
          </div>

          {/* Express */}
          <div>
            <Dropdown
              label="Express"
              value={commonData.express}
              onChange={(item) => {
                setCommonData((prev) => ({
                  ...prev,
                  express: item.value,
                }));
            
                setErrors((prev) => ({
                  ...prev,
                  express: "",
                }));
              }}
              options={expressOptions}
              isRequired
              error={errors.express}
              selectClassName="w-full h-[36px] rounded-md border border-gray-300 pr-2 text-[15px] focus:ring-1 focus:ring-[#FF6600] focus:outline-none"
            />
          </div>
        </div>

        {/* 🔹 Table */}
        <div className="relative z-10 mt-4">

  {/* Table Container */}
  <div className="border border-gray-200 rounded-lg overflow-hidden">
    
    {/* Header */}
    <div className="grid grid-cols-11 bg-gray-50 text-[12px] font-semibold text-gray-600 px-2 py-2 !bg-[#ffe8d4] sticky top-0 z-10">
      <div className="text-center" >Weight (kg)</div>
      <div className="text-center" >Height (cm)</div>
      <div className="text-center" >Length (cm)</div>
      <div className="text-center" >Width (cm)</div>
      <div className="text-center" >Amount (₹)</div>
      <div className="text-center" >Fuel (₹)</div>
      <div className="text-center" >GST (%)</div>
      <div className="text-center" >Total (₹)</div>
      <div className="text-center" >+Wt (₹)</div>
      <div className="text-center" >+Amt (₹)</div>
      <div className="text-center"> </div>
    </div>

    {/* Scrollable Body */}
  <div className="max-h-[260px] overflow-y-auto  custom-scrollbar">
    {/* Rows */}
      {rows.map((row, i) => (
        <div
          key={i}
          className="grid grid-cols-11 gap-1 px-2 py-2 border-t items-center hover:bg-gray-50 transition !pb-4"
        >
          {[
            "weight",
            "height",
            "length",
            "width",
            "chargesAmount",
            "fuelCharges",
            "gst",
            "totalCharges",
            "additionalWeightUnit",
            "additionalRate",
          ].map((field, idx) => {
            const isNumberField = [
              "weight",
              "height",
              "length",
              "width",
              "chargesAmount",
              "fuelCharges",
              "gst",
              "totalCharges",
              "additionalWeightUnit",
              "additionalRate",
            ].includes(field);
  
            return (
              <div key={field} className="relative">
                <input
                  value={row[field]}
                  disabled={field === "totalCharges"}
                  onChange={(e) =>
                    handleRowChange(i, field, e.target.value)
                  }
                  onBlur={(e) => validateField(i, field, e.target.value)}
                  className={`
                    w-full h-[34px] px-2 text-[13px] rounded-md border transition-all
                    ${errors?.[i]?.[field] 
                      ? "border-red-500 bg-red-50 focus:ring-red-400" 
                      : "border-gray-300 focus:ring-[#FF6600]"}
                    ${isNumberField ? "text-right" : "text-left"}
                    outline-none
                    ${field === "totalCharges" ? "bg-gray-100 cursor-not-allowed" : ""}
                  `}
                />
  
                {/* Error */}
                {errors?.[i]?.[field] && (
                  <p className="text-[10px] text-red-500 absolute top-full">
                    {errors[i][field]}
                  </p>
                )}
              </div>
            );
          })}
  
          {/* Delete */}
          <div className="text-center">
            <button
              onClick={() => removeRow(i)}
              disabled={rows.length === 1}
              className="text-gray-400 hover:text-red-500 text-lg btn btn-submit text-[#FFFFF]"
            >
            <img
              src={CrossIcon}
              alt="Close"
              className="w-5 h-5 cursor-pointer hover:rotate-90 transition-transform z-20"
            />
            </button>
          </div>
        </div>
      ))}
  </div>
  </div>

  {/* Add Row */}
  <div className="mt-3">
      <button
        onClick={addRow}
        className="flex items-center gap-2 text-[#FF6600] text-sm font-medium hover:underline"
      >
        + Add another slab
      </button>
    </div>
  </div>

        {/* 🔹 Footer */}
        <div className="flex justify-center gap-4 mt-6">
          <button 
            onClick={handleClose} 
            className="btn btn-back !rounded-[8px] w-[133px] h[33px]"
          >
            Cancel
          </button>
          <button 
            onClick={handleSubmit} 
            className="btn btn-submit !rounded-[8px] w-[133px] h[33px]"
          >
            Submit
          </button>
        </div>
      </div>

      {showSuccessModal && (
        <SuccessModal
          show={showSuccessModal}
          handleClose={handleCloseModal}
          successMessage={successMessage}
        />
      )}

      {showDuplicateModal && (
        <DuplicateModal
          show={showDuplicateModal}
          data={duplicateData}
          onSkip={() => handleCreateBulkCharges(finalPayload, "SKIP")}
          onOverride={() => handleCreateBulkCharges(finalPayload, "OVERRIDE")}
          onClose={() => setShowDuplicateModal(false)}
        />
      )}
    </div>
  );
};

export default AddChargeMasterMultiModal;